import { createFileRoute } from "@tanstack/react-router";

import { RequireCapability } from "@components/RequireCapability.tsx";
import { ALARM_READ } from "@/AccessPermissions.ts";
import { Alarms } from "@/features/alarms/components/Alarms.tsx";

export const Route = createFileRoute("/alarms/")({
  component: () => (
    <RequireCapability oneOf={[ALARM_READ]}>
      <Alarms />
    </RequireCapability>
  ),
  staticData: { breadcrumb: "menu.alarms" }
});
